function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeCircleEnhancedWeathering({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#808389",
    style: {
      stroke: "#808389",
      stroke: "color(display-p3 0.5020 0.5137 0.5373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26486 24.975H20.5439M9.26486 24.975L8.0564 15.3073L11.279 10.4734M9.26486 24.975L18.127 12.8904M20.5439 24.975L24.1693 21.3496L23.3637 11.6819M20.5439 24.975L18.127 12.8904M23.3637 11.6819L18.127 7.25085L11.279 10.4734M23.3637 11.6819L18.127 12.8904M11.279 10.4734L18.127 12.8904",
    stroke: "#808389",
    style: {
      stroke: "#808389",
      stroke: "color(display-p3 0.5020 0.5137 0.5373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleEnhancedWeathering);
export default __webpack_public_path__ + "static/media/project-type-circle-enhanced-weathering.58f32eab89b33a37592ec2705c14ba12.svg";
export { ForwardRef as ReactComponent };